<template>
  <div class="bg-neutral-light-9 border-neutral-light-5 rounded-lg border p-2">
    <slot />
  </div>
</template>
